import React from "react";
import { useNavigate } from "react-router-dom";
import { FiChevronsRight } from "react-icons/fi";
import "./PointWarning.css";

const PointWarning = ({ title, userPoint }) => {
  const navigate = useNavigate();
  let warningMessage = null;
  let bgColor = "bg-red-50";
  let borderColor = "border-red-200";
  let textColor = "text-red-600";

  if (userPoint < 10) {
    warningMessage =
      "Bạn không đủ điểm để tạo bài viết và đăng bài tự động. Vui lòng nạp thêm điểm để tiếp tục sử dụng. Xin cám ơn";
  } else if (userPoint < 100) {
    warningMessage =
      "Số điểm của bạn đang thấp! Nạp thêm điểm để tránh ảnh hưởng đến chức năng đăng bài tự động";
    bgColor = "bg-yellow-50";
    borderColor = "border-yellow-200";
    textColor = "text-yellow-600";
  }

  if (!warningMessage) {
    return null;
  }

  return (
    <div className="flex justify-center">
      <div
        onClick={() => navigate("/pricing")}
        className={`mb-8 p-4 ${bgColor} border ${borderColor} rounded-md inline-block cursor-pointer hover:opacity-90`}
      >
        <p className={`${textColor} font-medium text-center`}>
          {warningMessage}
        </p>
        <p
          className={`${textColor} text-sm text-center mt-2 flex items-center justify-center gap-2`}
        >
          <p className="pointing-hand-animation mr-1">👉</p>
          <span>Click để nạp điểm ngay</span>
        </p>
      </div>
    </div>
  );
};

export default PointWarning;
